import * as React from "react";
import { FunctionComponent, useRef, useEffect } from "react";
import { Language, PageState, MainMenuItem } from "../types";
import MainMenuLevelLeftNav from "./MainMenuLevelLeftNav";
import Icon from "./Icon";
import { passiveEventIfSupported } from "../utils/utils";

interface Props {
  isPreview: boolean;
  languageId: Language;
  pages: PageState;
  currentMenuItem: MainMenuItem;
  activePagePath: string[];
  fallbackLanguageId: Language | undefined;
  onClose: () => void;
}

const LeftOverlaySubmenu: FunctionComponent<Props> = ({
  isPreview,
  languageId,
  currentMenuItem,
  pages,
  activePagePath,
  fallbackLanguageId,
  onClose,
}) => {
  const submenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      const target = event.target as Element | null;
      const clickedOutside = !submenuRef.current?.contains(target);
      clickedOutside && onClose();
    };
    document.addEventListener("click", onClick, passiveEventIfSupported);

    return () => {
      document.removeEventListener("click", onClick);
    };
  }, []);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      event.keyCode === 27 && onClose();
    };
    document.addEventListener("keydown", onKeyDown, passiveEventIfSupported);

    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);

  return (
    <div ref={submenuRef} className="LeftOverlayNav__Submenu">
      <button
        className="Btn--bare LeftOverlayNav__BackBtn"
        type="button"
        onClick={onClose}
      >
        <Icon glyph="arrow-left" />
      </button>

      <ul className="MainMenu__List MainMenu__ListLevel0">
        <MainMenuLevelLeftNav
          currentMenuItem={currentMenuItem}
          isPreview={isPreview}
          languageId={languageId}
          parentId={currentMenuItem.id}
          pages={pages}
          menuLevel={0}
          activePagePath={activePagePath}
          fallbackLanguageId={fallbackLanguageId}
          onMenuItemClick={onClose}
        />
      </ul>
    </div>
  );
};

export default LeftOverlaySubmenu;
